module.exports = __webpack_public_path__ + "img/ai2.16b04817.png";